exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.download-cover[data-v-e04cd772] {\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n.download-cover .cover-img[data-v-e04cd772] {\n  display: block;\n  width: 8.266667rem;\n  height: 3.973333rem;\n  margin: 0.56rem auto;\n}", ""]);

// exports
